import React from 'react';
import BlogPost from '../../../components/BlogPost';

const VulnerabilityManagementSystemContainers = () => (
  <BlogPost
    breadcrumbItems={[
      { path: '/', label: 'Home' },
      { path: '/blog', label: 'Blog' },
      { path: '/blog/cloud-security-series', label: 'Cloud Security Series' },
      {
        path: '/blog/cloud-security-series/vulnerability-management-system-containers',
        label: 'Vulnerability Management System – Part 2: Containers',
      },
    ]}
    title="Vulnerability Management System – Part 2: Containers"
    date="Dec 12, 2024"
    content={
      <>
        <section className="blog-post__section">
          <h2>Vulnerability Management System. Part 2: Containers</h2>
          <p>Cloud Infrastructure Security Series #7. 🎯 Vulnerability Management</p>
          <p>
            In the original post we defined steps to implement a bullet-proof Cloud Infrastructure
            Security Posture. Now it's time to dive into the topic of{' '}
            <strong>🎯 Vulnerability Management</strong>. See Part 1: Hosts to learn about hardening
            pipelines for virtual host images (AMIs).
          </p>
          <p>
            <strong>❓ How would you approach the implementation of the following?</strong>
            <br />
            – Scan container images, applications, hosts for Vulnerabilities;
            <br />– Perform Regular Host and Container Security Patching and Version Upgrades;
          </p>
          <p>
            <strong>
              💪 Here is how, and while it's quite challenging, it is <em>very</em> rewarding from
              the cybersecurity perspective:
            </strong>
          </p>
          <p>
            <b>— Part 2 – Containers —</b>
          </p>
          <ol>
            <li>
              Choose a <b>base</b> Operating System (OS) for your container images, and make it a
              standard across your cloud environment. Ensure that the OS is actively maintained and
              supported. It is a best practice to choose a base OS for container images matching
              your selected base OS for the AMIs.
            </li>
            <li>
              Establish "Hardening" pipeline for your base OS image to produce what is usually
              called a <b>Golden Container Image</b>. Use the same pipeline orchestration tools you
              are using to produce your Golden AMI.
            </li>
            <li>
              Choose the hardening benchmarks that apply to your particular case and implement
              security recommendations into your image hardening pipeline. Good examples are:
              <ul className="blog-post__indented-list">
                <li>
                  CIS Docker Benchmarks (
                  <a href="https://lnkd.in/ezJQ_Cw6" target="_blank" rel="noopener noreferrer">
                    link
                  </a>
                  ) maintained by Center for Internet Security.
                </li>
                <li>
                  DoD Guidance on Container Image Creation and Deployment (
                  <a href="https://lnkd.in/en_WPBd3" target="_blank" rel="noopener noreferrer">
                    link
                  </a>
                  )
                </li>
              </ul>
              To save you time on implementing these security recommendations, you may choose to
              adopt an already-hardened base container image from a trusted public registry, such as
              United States Department of Defense's Iron Bank (
              <a href="https://lnkd.in/eYzub-Gj" target="_blank" rel="noopener noreferrer">
                link
              </a>
              ).
            </li>
            <li>
              Add verification step to your hardening pipeline, to ensure that all security patches
              have been applied. Automated tests on CIS Benchmarks are available via Docker Bench
              for Security (
              <a href="https://lnkd.in/e_7nXBxp" target="_blank" rel="noopener noreferrer">
                link
              </a>
              ) on GitHub; to verify DISA STIGs implementation, you could use OpenSCAP tools such
              as, for example, <code>oscap-containers</code> (
              <a href="https://lnkd.in/eNZwrhCZ" target="_blank" rel="noopener noreferrer">
                link
              </a>
              ).
            </li>
          </ol>
          <p>
            Now, we have covered the Security Patching side of things for Hosts (in Part 1) and
            Containers (here). This is a good portion of the VMS already, but the story has not
            finished yet.
          </p>
          <p>to be cont'd…</p>
        </section>
      </>
    }
    cta={{
      title: 'We Are Here to Help!',
      text: "Struggling to set up or simplify your SOC 2 compliance? Our expert team at DevSecOps, Inc. specializes in making compliance manageable and straightforward for lean startups. We've successfully helped numerous startups quickly and affordably achieve compliance without sacrificing agility.",
      buttonText: `Let's Talk`,
      buttonHref: '/contact-us',
    }}
    prevPost={{
      href: '/blog/cloud-security-series/vulnerability-management-system',
      label: 'Vulnerability Management System (VMS)',
    }}
    nextPost={{
      href: '/blog/vulnerability-management-system-part-3',
      label: 'Next: Vulnerability Management System Part 3 - Runtime',
    }}
  />
);

export default VulnerabilityManagementSystemContainers;
